import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "score-box"
}
const _hoisted_2 = {
  key: 1,
  class: "score-box"
}
const _hoisted_3 = {
  key: 0,
  class: "score-box weighted-score grade"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 3,
  class: "score-box weighted-score"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 4,
  class: "calculation-details"
}
const _hoisted_12 = { class: "calculation-table" }
const _hoisted_13 = { class: "total-row" }
const _hoisted_14 = { colspan: "3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["target-scores-section", { 'grade-select-large-font': _ctx.gradeSelectLargeFont }]),
    style: _normalizeStyle({
      'border-bottom-left-radius': _ctx.noBottomBorderRadius ? '0' : '18px',
      'border-bottom-right-radius': _ctx.noBottomBorderRadius ? '0' : '18px',
      'border-top-left-radius': _ctx.noTopBorderRadius ? '0' : '18px',
      'border-top-right-radius': _ctx.noTopBorderRadius ? '0' : '18px',
  })
  }, [
    _createVNode(_component_ion_row, { class: "ion-text-center subject-scores-row" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          size: "12",
          style: {"background":"#2f2f2f","color":"#fff"}
        }, {
          default: _withCtx(() => [
            (!_ctx.passIcon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title) + "  ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.title) + "   ", 1),
                  _createVNode(_component_ion_icon, {
                    color: "success",
                    icon: _ctx.passIcon,
                    size: "small"
                  }, null, 8, ["icon"]),
                  _cache[3] || (_cache[3] = _createTextVNode("Pass   ")),
                  _createVNode(_component_ion_icon, {
                    color: "danger",
                    icon: _ctx.passIcon,
                    size: "small"
                  }, null, 8, ["icon"]),
                  _cache[4] || (_cache[4] = _createTextVNode("Not Pass  "))
                ]))
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSubjects, (subject) => {
          return (_openBlock(), _createBlock(_component_ion_col, {
            key: subject.shortName,
            class: "subject-col"
          }, {
            default: _withCtx(() => [
              (_ctx.readonly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getSubjectGrade(subject.id) || '-'), 1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "score-box grade-select",
                    onClick: ($event: any) => (_ctx.setPopoverOpen('grades', true, $event, subject.id))
                  }, _toDisplayString(_ctx.getSubjectGrade(subject.id) || '-'), 9, _hoisted_4)),
              (!_ctx.hideSubjectNames)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "score-box subject-name",
                    onClick: ($event: any) => (_ctx.checkOpenEditSubjectModal(subject))
                  }, _toDisplayString(subject.shortName), 9, _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.fromDeckView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.getSubjectGrade(subject.id) ? _ctx.getWeightedScore(_ctx.program, subject.id, _ctx.getSubjectGrade(subject.id)).weightedScore : '0'), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.fromDeckView)
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 0,
          style: {"font-size":"0.85em","color":"#fff"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              style: _normalizeStyle([{"align-content":"center","background":"#656565"}, { 'background-color': `var(--ion-color-${_ctx.getColorForScore()}` }])
            }, {
              default: _withCtx(() => [
                _createElementVNode("b", null, _toDisplayString(_ctx.calculateBest5Scores()), 1),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                (_ctx.notMeetProgramMinGradeRequirements())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Not meet program entrance requirements "))
                  : (!_ctx.passProgramElectiveRequirements())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Not meet program elective requirements "))
                    : (!_ctx.passUniEntranceRequirements())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Not meet minimum university entrance requirements (332) "))
                      : (_ctx.getAvailableScoreType(_ctx.program) != 'N/A')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getColorForScore() == 'danger' ? 'Not pass' : 'Pass') + " the program's " + _toDisplayString(_ctx.getAvailableScoreType(_ctx.program)), 1))
                        : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "calculation-details-toggle",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCalculationDetails && _ctx.toggleCalculationDetails(...args)))
                }, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.calculationDetailsOpen ? _ctx.chevronUp : _ctx.chevronDown
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.calculationDetailsOpen ? 'Hide calculation details' : 'Show calculation details'), 1)
                ]),
                (_ctx.calculationDetailsOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("table", _hoisted_12, [
                        _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "#"),
                            _createElementVNode("th", null, "Subject"),
                            _createElementVNode("th", null, "Min grade"),
                            _createElementVNode("th", null, "Your grade"),
                            _createElementVNode("th", null, "Score"),
                            _createElementVNode("th", null, "Weight"),
                            _createElementVNode("th", null, "Weighted score")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculationSteps, (step, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              style: _normalizeStyle({ background: step.missingSubjects ? `var(--ion-color-danger)` : (step.scoreObj?.failedMinGrade ? `var(--ion-color-medium)` : undefined) })
                            }, [
                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", null, _toDisplayString(step.missingSubjects ? step.missingSubjects.join('/') : (step.bonusPercent ? 'Bonus' : _ctx.getSubjectName(step.scoreObj?.subjectId))), 1),
                              _createElementVNode("td", null, _toDisplayString(step.scoreObj?.minGrade || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(step.scoreObj?.grade || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(step.scoreObj?.score || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(step.bonusPercent || step.scoreObj?.weighting || (step.multiplier ? step.multiplier : '1')), 1),
                              _createElementVNode("td", null, _toDisplayString(step.weightedScore || (step.scoreObj?.weightedScore ? (step.scoreObj?.weightedScore * (step.multiplier || 1)).toFixed(1) : '-')), 1)
                            ], 4))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_13, [
                            _cache[5] || (_cache[5] = _createElementVNode("td", {
                              colspan: "4",
                              class: "total-label"
                            }, "Total", -1)),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.calculateBest5Scores()), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1,
              __: [7]
            }, 8, ["style"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_popover, {
      isOpen: _ctx.popoverState.grades,
      event: _ctx.popoverEvent,
      "dismiss-on-select": true,
      onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPopoverOpen('grades', false, $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grades, (grade) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                lines: "full",
                key: grade,
                onClick: ($event: any) => (_ctx.setTargetScore(grade))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(grade), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128)),
            _createVNode(_component_ion_item, {
              lines: "full",
              button: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTargetScore('')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("-")
                  ])),
                  _: 1,
                  __: [8]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["isOpen", "event"])
  ], 6))
}